import { Button } from 'components';
import { ManagementDialogForm } from 'components/Management/ManagementDialogForm';
import { DashboardTitle } from 'components/Titles';
import { useManagers } from 'hooks/useManagement';
import { useDisclose } from 'hooks/utilHooks';
import { FC, useEffect } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';

import { ManagementList } from './ManagementList';

export const Management: FC = () => {
  const { loadingList, getManagersCb, managers } = useManagers();

  const { isOpen, onClose, onOpen } = useDisclose();

  useEffect(() => {
    getManagersCb(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GERENCIADOR DE ACESSOS" />
      </Grid>

      <Grid item xs={12}>
        <ManagementList loading={loadingList} {...managers} />
      </Grid>

      <Grid
        container
        item
        spacing={2}
        xs={12}
        alignItems="stretch"
        justifyContent="flex-end"
      >
        <Grid item>
          <Button
            size="medium"
            disabled={managers.companyUsers.length === 5}
            startIcon={<AddIcon />}
            onClick={onOpen}
            sx={{ color: '#FFFFFF' }}
          >
            Cadastrar
          </Button>
        </Grid>
      </Grid>

      <ManagementDialogForm isOpen={isOpen} onClose={onClose} />
    </Grid>
  );
};
